export const TEST_ID = 'noEntryIcon';
